





















import { Component, Prop, Mixins } from 'vue-property-decorator'
import Axios from 'axios'
import { Playlist, PLAYLIST_TYPES } from '@/classes/playlist'
import { getPlaylistsFlattenedRecursive } from '@/helpers/library'
import { LibraryMixin } from '@/mixins'
import * as _ from 'lodash'
import { USAGE_STAT_FEATURES } from '../../../../../system/usage-stats'

enum SORT_METHODS {
  AlphaAsc = 'alpha_asc',
  AlphaDesc = 'alpha_desc',
  TrackCountAsc = 'track_count_asc',
  TrackCountDesc = 'track_count_desc'
}

@Component({
  components: {
    BaseAction: require('./_Base').default
  }
})
export default class Create extends Mixins(LibraryMixin) {
  @Prop()
  selectedPlaylists: Playlist[]

  sortMethod: SORT_METHODS = SORT_METHODS.AlphaAsc

  get validation(): { message?: string, valid: boolean } {
    if (this.selectedPlaylists.length === 0 || (this.selectedPlaylists.length === 1 && this.selectedPlaylists[0].type !== PLAYLIST_TYPES.Folder)) {
      return { message: 'Please select two or more playlists or one playlist folder', valid: false }
    }

    if (!this.selectedPlaylists.every(x => this.parentPlaylist && this.parentPlaylist.playlists.some(y => y._id === x._id))) return { message: 'Please only select playlists in the same folder', valid: false }

    return { valid: true }
  }

  get parentPlaylist(): Playlist | undefined {
    if (this.selectedPlaylists.length === 0) return

    return getPlaylistsFlattenedRecursive(this.library.playlists, PLAYLIST_TYPES.Folder).find(x => x.playlists.some(y => y._id === this.selectedPlaylists[0]._id))
  }

  async save() {
    if (!this.validation.valid || !this.parentPlaylist) return

    let sortedPlaylists: Playlist[]
    let parentPlaylist: Playlist

    if (this.selectedPlaylists.length === 1 && this.selectedPlaylists[0].type === PLAYLIST_TYPES.Folder) {
      sortedPlaylists = this.selectedPlaylists[0].playlists
      parentPlaylist = this.selectedPlaylists[0]
    } else {
      sortedPlaylists = this.selectedPlaylists
      parentPlaylist = this.parentPlaylist
    }

    if (this.sortMethod === SORT_METHODS.AlphaAsc) {
      sortedPlaylists = _.sortBy(sortedPlaylists, (x) => x.name.toLowerCase())
    } else if (this.sortMethod === SORT_METHODS.AlphaDesc) {
      sortedPlaylists = _.sortBy(sortedPlaylists, (x) => x.name.toLowerCase()).reverse()
    } else if (this.sortMethod === SORT_METHODS.TrackCountAsc) {
      sortedPlaylists = _.sortBy(sortedPlaylists, (x) => x.tracks.length).reverse()
    } else if (this.sortMethod === SORT_METHODS.TrackCountDesc) {
      sortedPlaylists = _.sortBy(sortedPlaylists, (x) => x.tracks.length)
    } else {
      throw new Error('unknown sort method ' + this.sortMethod)
    }

    const playlistIdObj = Object.fromEntries(sortedPlaylists.map(x => [x._id, true]))

    const indici: number[] = []

    for (let i = 0; i < parentPlaylist.playlists.length; i++) {
      if (playlistIdObj[parentPlaylist.playlists[i]._id]) {
        indici.push(i)
      }

      if (indici.length >= sortedPlaylists.length) break
    }

    const allPlaylistIds: string[] = parentPlaylist.playlists.map(x => x._id)

    for (let i = 0; i < indici.length; i++) {
      const targetIndex = indici[i]

      allPlaylistIds[targetIndex] = sortedPlaylists[i]._id
    }

    window.addUsageStat(USAGE_STAT_FEATURES.ManagePlaylist, 'sort', 'confirm', {
      method: this.sortMethod
    })

    return Axios.post('/playlist/reorder-folder', {
      parentId: parentPlaylist._id,
      playlistIds: allPlaylistIds
    }).then((res) => {
      this.$buefy.notification.open('Sorted playlists')

      return res
    })
  }
}
